import { __decorate, __metadata } from "tslib";
import { ApiClientDataSource, ApiClientLookupDataSource } from './ApiDataSource';
import { injectable } from 'inversify';
import { DataCacheEntry } from './DataCacheEntry';
/** Service for managing cached data. */
var CachedDataService = /** @class */ (function () {
    function CachedDataService(base) {
        this.dataSources = [];
        this.children = [];
        if (base) {
            base.children.push(this);
        }
    }
    CachedDataService.prototype.register = function (apiEndpointOrDataSource, lifeTimeMinutes, defaultData) {
        if (defaultData === void 0) { defaultData = []; }
        var apiSource;
        if (apiEndpointOrDataSource.fetchDataAsync !== undefined) {
            apiSource = apiEndpointOrDataSource;
        }
        else if (apiEndpointOrDataSource instanceof Function) {
            apiSource = new ApiClientDataSource(apiEndpointOrDataSource, defaultData);
        }
        else {
            throw Error("Unknown data source");
        }
        var cacheEntry = new DataCacheEntry(apiSource, lifeTimeMinutes);
        ;
        this.dataSources.push(cacheEntry);
        return cacheEntry;
    };
    /**
     * Registers an api datasource which contains a list of data. The data from the api endpoint will be deserialised into models of the provided child type.
     * @param childType Child type to create when deserialising data.
     * @param apiMethod Api client method from which to get data.
     * @param lifeTimeMinutes No of minutes from the data retrieval time that the cache is valid for.
     * @param dbSet DbSet for offline storage.
     */
    CachedDataService.prototype.registerList = function (childType, apiMethod, lifeTimeMinutes, dbSet) {
        var dataSource = new ApiClientLookupDataSource(apiMethod, childType, undefined, dbSet);
        var cacheEntry = new DataCacheEntry(dataSource, lifeTimeMinutes);
        ;
        this.dataSources.push(cacheEntry);
        return cacheEntry;
    };
    /** Expires all data */
    CachedDataService.prototype.expireAll = function (expireDescendants) {
        if (expireDescendants === void 0) { expireDescendants = false; }
        for (var _i = 0, _a = this.dataSources; _i < _a.length; _i++) {
            var datasource = _a[_i];
            datasource.expire();
        }
        if (expireDescendants) {
            for (var _b = 0, _c = this.children; _b < _c.length; _b++) {
                var dataCache = _c[_b];
                dataCache.expireAll(expireDescendants);
            }
        }
    };
    CachedDataService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [CachedDataService])
    ], CachedDataService);
    return CachedDataService;
}());
export { CachedDataService };
